export interface BunddleTextType {
    parentVariantId?: string;
    subs?: BundleItemType[];
    type?: 'bundle' | 'customize';
    link_buy?: string;
    name?: string;
    power?: string;
    desc?: string;
    quantity?: number;
    tip?: string;
}

export interface BundleItemType extends BunddleTextType {
    variantId?: string;
    productId?: string;
    sku?: string;
    inventoryQuantity?: number;
    inventoryPolicy?: string;
    price?: number;
    compareAtPrice?: number;
    img?: string;
    variantImg?: string;
    productTitle?: string;
    skuTitle?: string;
    handle?: string;
}

export interface BundleIdsType {
    [key: string]: BundleItemType[];
}

export const bundleIds: BundleIdsType = {
    us: [
        {
            productId: '15386143096905',
            variantId: '54718705008713',
            subs: [
                {
                    parentVariantId: '54718705008713',
                    productId: '6618094960713',
                    variantId: '39998021697609',
                },
                {
                    parentVariantId: '54718705008713',
                    productId: '7049853632585',
                    variantId: '41064248836169',
                },
                {
                    parentVariantId: '54718705008713',
                    productId: '15389745971273',
                    variantId: '55069632790601',
                },
            ],
        },
        {
            productId: '15386143096905',
            variantId: '54718705041481',
            subs: [
                {
                    parentVariantId: '54718705041481',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54718705041481',
                    productId: '7049853632585',
                    variantId: '41064248836169',
                },
                {
                    parentVariantId: '54718705041481',
                    productId: '15389745971273',
                    variantId: '55069632790601',
                },
            ],
        },
        {
            productId: '15386143096905',
            variantId: '54692148871241',
            subs: [
                {
                    parentVariantId: '54692148871241',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54692148871241',
                    productId: '15302788022345',
                    variantId: '54348224954441',
                },
                {
                    parentVariantId: '54692148871241',
                    productId: '6618094960713',
                    variantId: '39998021697609',
                },
            ],
        },
        {
            productId: '15386143096905',
            variantId: '54692157751369',
            subs: [
                {
                    parentVariantId: '54692157751369',
                    productId: '6899592167497',
                    variantId: '40515604512841',
                },
                {
                    parentVariantId: '54692157751369',
                    productId: '15302788022345',
                    variantId: '54348224954441',
                },
            ],
        },
        {
            productId: '15386143096905',
            variantId: '54718705074249',
            subs: [
                {
                    parentVariantId: '54718705074249',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54718705074249',
                    productId: '7049853632585',
                    variantId: '41064248836169',
                },
                {
                    parentVariantId: '54718705074249',
                    productId: '15389745971273',
                    variantId: '55069632790601',
                },
            ],
        },
        {
            productId: '15386143096905',
            variantId: '54718705107017',
            subs: [
                {
                    parentVariantId: '54718705107017',
                    productId: '6618094960713',
                    variantId: '39998021697609',
                },
                {
                    parentVariantId: '54718705107017',
                    productId: '7049853632585',
                    variantId: '41064248836169',
                },
                {
                    parentVariantId: '54718705107017',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
            ],
        },
        {
            productId: '54692157751369',
            variantId: '54718705139785',
            subs: [
                {
                    parentVariantId: '54718705139785',
                    productId: '6618094960713',
                    variantId: '39998021697609',
                },
                {
                    parentVariantId: '54718705139785',
                    productId: '7049853632585',
                    variantId: '41064248836169',
                },
                {
                    parentVariantId: '54718705139785',
                    productId: '15389745971273',
                    variantId: '55069632790601',
                },
            ],
        },
        {
            productId: '15386143096905',
            variantId: '54692157784137',
            subs: [
                {
                    parentVariantId: '54692157784137',
                    productId: '6899592167497',
                    variantId: '40515604512841',
                },
                {
                    parentVariantId: '54692157784137',
                    productId: '15302788022345',
                    variantId: '54348224954441',
                },
            ],
        },
        {
            productId: '15386143096905',
            variantId: '54692157816905',
            subs: [
                {
                    parentVariantId: '54692157816905',
                    productId: '6899592167497',
                    variantId: '40515604512841',
                },
                {
                    parentVariantId: '54692157816905',
                    productId: '15302788022345',
                    variantId: '54348224954441',
                },
            ],
        },
        {
            productId: '15386143096905',
            variantId: '54692157849673',
            subs: [
                {
                    parentVariantId: '54692157849673',
                    productId: '7003545108553',
                    variantId: '41670394576969',
                },
                {
                    parentVariantId: '54692157849673',
                    productId: '15302788022345',
                    variantId: '54348224954441',
                },
                {
                    parentVariantId: '54692157849673',
                    productId: '6618094960713',
                    variantId: '39998021697609',
                },
            ],
        },
    ],
    ca: [
        {
            productId: '15164531016051',
            variantId: '62106740556147',
            subs: [
                {
                    parentVariantId: '62106740556147',
                    productId: '7287920001178',
                    variantId: '42092770263194',
                },
                {
                    parentVariantId: '62106740556147',
                    productId: '8132015980698',
                    variantId: '44676925358234',
                },
                {
                    parentVariantId: '62106740556147',
                    productId: '15170280161651',
                    variantId: '62341144052083',
                },
            ],
        },
        {
            productId: '15164531016051',
            variantId: '62106740654451',
            subs: [
                {
                    parentVariantId: '62106740654451',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62106740654451',
                    productId: '8132015980698',
                    variantId: '44676925358234',
                },
                {
                    parentVariantId: '62106740654451',
                    productId: '15170280161651',
                    variantId: '62341144052083',
                },
            ],
        },
        {
            productId: '15164531016051',
            variantId: '62060629590387',
            subs: [
                {
                    parentVariantId: '62060629590387',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62060629590387',
                    productId: '15070037180787',
                    variantId: '52476912992627',
                },
                {
                    parentVariantId: '62060629590387',
                    productId: '7287920001178',
                    variantId: '42092770263194',
                },
            ],
        },
        {
            productId: '15164531016051',
            variantId: '62106740785523',
            subs: [
                {
                    parentVariantId: '62106740785523',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62106740785523',
                    productId: '8132015980698',
                    variantId: '44676925358234',
                },
                {
                    parentVariantId: '62106740785523',
                    productId: '15170280161651',
                    variantId: '62341144052083',
                },
            ],
        },
        {
            productId: '15164531016051',
            variantId: '62106740621683',
            subs: [
                {
                    parentVariantId: '62106740621683',
                    productId: '7287920001178',
                    variantId: '42092770263194',
                },
                {
                    parentVariantId: '62106740621683',
                    productId: '8132015980698',
                    variantId: '44676925358234',
                },
                {
                    parentVariantId: '62106740621683',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
            ],
        },
        {
            productId: '15164531016051',
            variantId: '62106740719987',
            subs: [
                {
                    parentVariantId: '62106740719987',
                    productId: '7287920001178',
                    variantId: '42092770263194',
                },
                {
                    parentVariantId: '62106740719987',
                    productId: '8132015980698',
                    variantId: '44676925358234',
                },
                {
                    parentVariantId: '62106740719987',
                    productId: '15170280161651',
                    variantId: '62341144052083',
                },
            ],
        },
        {
            productId: '15164531016051',
            variantId: '62060629688691',
            subs: [
                {
                    parentVariantId: '62060629688691',
                    productId: '7874417328282',
                    variantId: '43762530025626',
                },
                {
                    parentVariantId: '62060629688691',
                    productId: '15070037180787',
                    variantId: '52476912992627',
                },
            ],
        },
        {
            productId: '15164531016051',
            variantId: '62060629655923',
            subs: [
                {
                    parentVariantId: '62060629655923',
                    productId: '7874417328282',
                    variantId: '43762530025626',
                },
                {
                    parentVariantId: '62060629655923',
                    productId: '15070037180787',
                    variantId: '52476912992627',
                },
            ],
        },
        {
            productId: '15164531016051',
            variantId: '62060629721459',
            subs: [
                {
                    parentVariantId: '62060629721459',
                    productId: '7296662896794',
                    variantId: '43874721824922',
                },
                {
                    parentVariantId: '62060629721459',
                    productId: '15070037180787',
                    variantId: '52476912992627',
                },
                {
                    parentVariantId: '62060629721459',
                    productId: '7287920001178',
                    variantId: '42092770263194',
                },
            ],
        },
    ],
};
